import React from 'react';
import {
  Box, FormControl,
} from '@mui/material';
import { CustomProvider, DateRangePicker } from 'rsuite';
import { ptBR } from 'rsuite/locales';
import 'rsuite/dist/rsuite-no-reset.min.css';
import './styles.css';

function DataRangePicker({
  inputLabel, dateRange, setDateRange, disabled = false,
}) {
  const handleChangeDate = (date) => {
    setDateRange(date);
  };

  return (
    <CustomProvider locale={ptBR}>
      <FormControl fullWidth sx={{ position: 'relative' }}>
        <Box id="range-picker">
          <DateRangePicker
            // preventOverflow
            style={{ height: 40 }}
            placeholder={inputLabel}
            format="dd/MM/yyyy"
            placement="auto"
            aria-describedby="range-picker-helper-text"
            editable={false}
            value={dateRange}
            onChange={handleChangeDate}
            disabled={disabled}
          />
        </Box>
      </FormControl>
    </CustomProvider>
  );
}

export default DataRangePicker;
